(function(){
  const sel = '.sorcie-fs';
  const fmtJPY = new Intl.NumberFormat('ja-JP',{style:'currency',currency:'JPY',maximumFractionDigits:0});

  async function refreshFS(){
    const els = document.querySelectorAll(sel);
    if(!els.length) return;
    try{
      const res = await fetch('/cart.js',{headers:{'Accept':'application/json'}});
      if(!res.ok) return;
      const cart = await res.json();                     // { total_price: ... } (サブユニット)
      const subtotal = Number(cart.total_price || 0);

      els.forEach(function(el){
        var threshold = Number(el.dataset && el.dataset.threshold ? el.dataset.threshold : 0);
        if(!threshold || threshold <= 0){ return; }      // ガード：しきい値未設定なら何もしない

        var delta = threshold - subtotal;
        var pct = Math.max(0, Math.min(100, Math.floor((subtotal/threshold)*100)));

        var barWrap = el.querySelector('.sorcie-fs__bar');
        var bar = el.querySelector('.sorcie-fs__bar span');
        var text = el.querySelector('.sorcie-fs__text');

        /* ▼ “確実にアニメさせる”小ワザ
             DOM差し替え直後でも次フレームで width をセットして transition を必ず発火させる */
        if(bar){
          // 一旦現在値を維持 → 次フレームで最終幅を適用
          requestAnimationFrame(function(){
            bar.style.width = pct + '%';
          });
        }

        if(delta > 0){
          if(text){ text.textContent = 'あと' + fmtJPY.format(delta/100) + 'で送料無料'; }
          if(barWrap){ barWrap.classList.remove('is-full'); }
        }else{
          if(text){ text.textContent = '送料無料になりました'; }
          if(barWrap){ barWrap.classList.add('is-full'); }
        }
      });
    }catch(e){
      // no-op
    }
  }

  // 初期表示＋カート操作後の更新
  document.addEventListener('DOMContentLoaded', refreshFS);
  document.addEventListener('cart:updated', refreshFS);
  document.addEventListener('cart:refresh', refreshFS);

  // フォールバック：数量変更 / 追加時
  ['submit','click','change'].forEach(function(ev){
    document.addEventListener(ev, function(e){
      if(
        (e.target && e.target.closest && e.target.closest('form[action*="/cart"]')) ||
        (e.target && e.target.closest && e.target.closest('button[name="add"]')) ||
        (e.target && e.target.closest && e.target.closest('[name="updates[]"]'))
      ){
        setTimeout(refreshFS, 700);
      }
    }, true);
  });

  // Section Rendering等でドロワーが差し替わっても更新
  new MutationObserver(function(){
    if(document.querySelector(sel)) refreshFS();
  }).observe(document.body,{childList:true,subtree:true});
})();
